export default function BallAvatar() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 8.52637H12.4925C10.3021 8.52637 8.52655 10.302 8.52655 12.4923V14.9999C11.9836 14.7435 14.7437 11.9834 15 8.52637Z"
        fill="#E9933E"
        className="path-fill"
      />
      <path
        d="M7.47368 14.9999V12.4923C7.47368 10.302 5.69806 8.52637 3.50772 8.52637H1.00018C1.25651 11.9834 4.01666 14.7435 7.47368 14.9999Z"
        fill="#E9933E"
        className="path-fill"
      />
      <path
        d="M15 7.47349C14.7437 4.01647 11.9836 1.25632 8.52655 1V3.50753C8.52655 5.69787 10.3021 7.47349 12.4925 7.47349H15Z"
        fill="#E9933E"
        className="path-fill"
      />
      <path
        d="M7.4735 1C4.01647 1.25632 1.25632 4.01647 1 7.47349H3.50753C5.69787 7.47349 7.4735 5.69787 7.4735 3.50753V1Z"
        fill="#E9933E"
        className="path-fill"
      />
      <path
        d="M5.74786 7.99995C6.72093 7.51376 7.51394 6.72074 8.0001 5.74768C8.4863 6.72074 9.27928 7.51376 10.2524 7.99995C9.27928 8.48612 8.4863 9.27913 8.0001 10.2522C7.51394 9.27913 6.72093 8.48612 5.74786 7.99995Z"
        fill="#E9933E"
        className="path-fill"
      />
    </svg>
  );
}
